import { GAME_ID, REDUX_ACTIONS } from 'a/sortItOut/data/constants';
import { retrieveQueue } from '../../content/curriculum';

export const initialState = {
  roundNumber: 1,
  categories: ['', ''],
  queue: [],
  sortedItems: {},
  currentQueueItem: 0,
  questionsAnswered: 0,
  answersCorrect: 0,
  answersIncorrect: 0,
  answerAttemptsCounters: {},
  interactionLocked: false,
};

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND: {
      const queue = retrieveQueue(action.payload.level, action.payload.set);
      const [{ categories }] = queue;

      return {
        ...initialState,
        categories: queue[0].categories,
        queue,
        currentQueueItem: queue.shift(),
        sortedItems: {
          [categories[0].split(' ')[0]]: [],
          [categories[1].split(' ')[0]]: [],
        },
        roundNumber: action.payload.level,
        setNumber: action.payload.set,
      };
    }
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:

      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    case REDUX_ACTIONS.MOVE_TO_CATEGORY: {
      const currentQueItem = state.currentQueueItem;
      const { payload: { category } } = action;

      return {
        ...state,
        sortedItems: {
          ...state.sortedItems,
          [category.split(' ')[0]]: [...state.sortedItems[category.split(' ')[0]], currentQueItem],
        },
      };
    }
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };

    case REDUX_ACTIONS.INCREMENT_ANSWERS_CORRECT:
      return {
        ...state,
        answersCorrect: state.answersCorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_ANSWERS_INCORRECT:
      return {
        ...state,
        answersIncorrect: state.answersIncorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_ATTEMPTS_COUNTER:
      return {
        ...state,
        answerAttemptsCounters: {
          ...state.answerAttemptsCounters,
          [action.payload.word]: (state.answerAttemptsCounters[action.payload.word] || 0) + 1,
        },
      };
    case REDUX_ACTIONS.NEXT_QUEUE_ITEM: {
      const prevQueue = state.queue.slice();
      const prevItem = state.currentQueueItem;

      if ((state.answerAttemptsCounters[prevItem.word] || 0) < 2 && !action.payload.answerIsCorrect) {
        prevQueue.push(prevItem);
        const nextItem = prevQueue.shift();

        return {
          ...state,
          categories: nextItem.categories,
          currentQueueItem: nextItem,
          queue: prevQueue,
        };
      }

      const nextItem = prevQueue.shift();
      return {
        ...state,
        categories: nextItem.categories,
        currentQueueItem: nextItem,
        queue: prevQueue,
      };
    }
    default:
      return state;
  }
};

export default roundReducer;
